<template>
  <div class="profile_settings">
    <v-flex xs10 style="margin: 20px auto;">
      <h1>Account settings</h1>
    </v-flex>
    <div class="profile_settings-inputs pa-5">
      <!--Form-->
      <v-form
        class="profile_settings-form"
        v-model="isFormValid"
        lazy-validation
        ref="form"
        @submit.prevent="handleSignupUser"
      >
        <!--Email field-->
        <v-flex xs12 sm5>
          <v-text-field
            outlined
            color="light-blue darken-4"
            prepend-inner-icon="fa-at"
            label="User email"
            autocomplete="email"
            :rules="emailRules"
            placeholder="Enter your email"
            v-model="user.userEmail"
          >
          </v-text-field>
        </v-flex>
        <!--Name field-->
        <v-flex xs12 sm5>
          <v-text-field
            outlined
            color="light-blue darken-4"
            prepend-inner-icon="fa-user-tag"
            label="User name"
            :rules="nameRules"
            placeholder="Enter your name"
            v-model="user.userName"
          >
          </v-text-field>
        </v-flex>
        <!--Create date field-->
        <v-flex xs12 sm5>
          <v-text-field
            outlined
            color="light-blue darken-4"
            label="Create date"
            readonly
            prepend-inner-icon="fa-clock"
            placeholder="Create date"
            v-model="user.createDate"
          >
          </v-text-field>
        </v-flex>
        <!--Language field-->
        <v-flex xs12 sm5>
          <v-text-field
            outlined
            color="light-blue darken-4"
            label="Language"
            prepend-inner-icon="fa-language"
            placeholder="Enter you preferred language"
            v-model="user.language"
          >
          </v-text-field>
        </v-flex>
        <!--Password field-->
        <v-flex xs12 sm5>
          <v-text-field
            outlined
            color="light-blue darken-4"
            label="Password"
            autocomplete="password"
            :type="showPass ? 'text' : 'password'"
            prepend-inner-icon="fa-lock"
            :append-icon="showPass ? 'fa-eye' : 'fa-eye-slash'"
            :rules="passwordRules"
            placeholder="Enter you password"
            v-model="password"
            @click:append="showPass = !showPass"
          >
          </v-text-field>
        </v-flex>
        <!--Confrim password-->
        <v-flex xs12 sm5>
          <v-text-field
            outlined
            color="light-blue darken-4"
            label="Confirm password"
            autocomplete="password"
            :type="showConfirmPass ? 'text' : 'password'"
            :append-icon="showConfirmPass ? 'fa-eye' : 'fa-eye-slash'"
            prepend-inner-icon="gavel"
            :rules="confirmPasswordRules.concat(passwordConfirmationRules)"
            placeholder="Confirm your password"
            v-model="confirmPassword"
            @click:append="showConfirmPass = !showConfirmPass"
          >
          </v-text-field>
        </v-flex>
        <!--Gender select-->
        <v-flex xs12 sm5>
          <v-select
            color="light-blue darken-4"
            v-model="user.gender"
            :items="['male', 'female']"
            label="Gender"
            :rules="requiredRules"
            prepend-inner-icon="fa-venus-mars"
            outlined
          ></v-select>
        </v-flex>
        <!--Country list-->
        <v-flex xs12 sm5>
          <v-select
            color="light-blue darken-4"
            v-model="user.country"
            :items="countryList"
            prepend-inner-icon="fa-globe"
            label="Country"
            :rules="requiredRules"
            outlined
            item-value="node.valId"
            item-text="node.valDesc"
          ></v-select>
        </v-flex>
        <!--State list-->
        <v-flex xs12 sm5>
          <v-select
            color="light-blue darken-4"
            v-model="user.state"
            :items="['active', 'passive']"
            label="State"
            :rules="requiredRules"
            outlined
          ></v-select>
        </v-flex>
        <!--Birth date-->
        <v-flex xs12 sm5>
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                color="light-blue darken-4"
                outlined
                v-model="user.birthDate"
                id="profile_Birth_Date"
                label="Birth Date"
                prepend-inner-icon="event"
                v-on="on"
                readonly
                :menu-props="{ contentClass: 'birthdate-selector' }"
              ></v-text-field>
            </template>
            <v-date-picker
              color="light-blue darken-4"
              id="profile_Birth_Date-datepicker"
              v-model="user.birthDate"
              @input="menu = false"
              :menu-props="{ contentClass: 'birthday-datepicker' }"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <!--Btns block-->
        <v-flex xs11>
          <v-btn color="#0277BD" type="submit" :disabled="userState">
            Update
          </v-btn>
        </v-flex>
      </v-form>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { validationRules } from "../../constants/global";

export default {
  name: "ProfileSettings",
  data() {
    return {
      clonedUser: undefined,
      showPass: false,
      showConfirmPass: false,
      isFormValid: true,
      password: "",
      confirmPassword: "",
      menu: false,
      emailRules: validationRules.email,
      nameRules: validationRules.name,
      requiredRules: validationRules.required,
      passwordRules: validationRules.password,
      confirmPasswordRules: validationRules.password
    };
  },
  created() {
    this.clonedUser = Object.assign({}, this.user);
  },
  computed: {
    ...mapGetters(["error", "user", "hasUser", "categoryValue"]),
    countryList() {
      if (this.categoryValue.edges) {
        return this.categoryValue.edges.filter(
          category => category.node.category.catName === "COUNTRY_LIST"
        );
      } else {
        return [];
      }
    },
    passwordConfirmationRules() {
      return () =>
        this.password === this.confirmPassword || "Password must match";
    },
    getPassword() {
      if (this.confirmPassword.length > 0) {
        return this.confirmPassword;
      } else {
        return "SportEcoSys123";
      }
    },
    userState() {
      if (
        JSON.stringify(this.clonedUser) === JSON.stringify(this.user) &&
        this.password == this.user.password &&
        this.confirmPassword == ""
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    handleSignupUser() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch("signUpUser", {
          userName: this.user.userName,
          userEmail: this.user.userEmail,
          birthDate: this.user.birthDate,
          gender: this.user.gender,
          password: this.getPassword,
          language: this.user.language,
          state: this.user.state,
          country: this.user.country,
          updateSource: "SportEcoSysApp"
        });
      } else {
        this.$toast.error("You need to fill in all the fields of the form");
      }
    },
    isEquivalent(a, b) {
      // Create arrays of property names
      var aProps = Object.getOwnPropertyNames(a);
      var bProps = Object.getOwnPropertyNames(b);

      // If number of properties is different,
      // objects are not equivalent
      if (aProps.length != bProps.length) {
        return false;
      }

      for (var i = 0; i < aProps.length; i++) {
        var propName = aProps[i];

        // If values of same property are not equal,
        // objects are not equivalent
        if (a[propName] !== b[propName]) {
          return false;
        }
      }

      // If we made it this far, objects
      // are considered equivalent
      return true;
    }
  }
};
</script>
<style lang="scss">
.profile {
  &_settings-form {
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-around;

    /* Change the white to any color */
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
      -webkit-box-shadow: 0 0 0 30px white inset !important;
    }
  }
}
</style>
